export default [
    {
        name: 'Projetos',
        url: '/sgtec/uabs/projetos',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'UABS'
        },
        regras: 'SGTEC-UABS-PRJ-00'
    },
    {
        name: 'Etapas',
        url: '/sgtec/uabs/etapas',
        icon: 'fa fa-tasks',
        badge: {
            variant: 'primary',
            text: 'UABS'
        },
        regras: 'SGTEC-UABS-ETP-00'
    },
    {
        name: 'Pagamentos',
        url: '/sgtec/uabs/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'UABS'
        },
        regras: 'SGTEC-UABS-PAG-00'
    }
]
